import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody53';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy53 = ({setBlank}) => {
 

    const headings = "<h4>Development Of An Integrated</h4><h2 style='display:inline-block;color:#ffffff;transform:scale(0.85);transform-origin:left;'>Hospitality investment Model</h2>";

  return (
    <>
        <Helmet>
        <title>Development Of An Integrated Hospitality Investment Model</title>
        <meta property="og:title" content="Development Of An Integrated Hospitality Investment Model" />
        <meta property='og:description' content='Development Of An Integrated Hospitality Investment Model'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy53" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy53
